import axios from 'axios'
import {BASE_URL, API_VERSION, BOOTHS} from '../endpoints'

export const GET_ALL_BOOTHS = 'GET_ALL_BOOTHS'
export const GET_BOOTH = 'GET_BOOTH'
export const ADD_BOOTH = 'ADD_BOOTH'
export const EDIT_BOOTH = 'EDIT_BOOTH'
export const DELETE_BOOTH = 'DELETE_BOOTH'
export const CLEAR_BOOTH = 'CLEAR_BOOTH'

export const getAllItems = (page, size, search) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${BOOTHS}/admin?page=${page}&size=${size}&search=${search}&admin=true`, options)
        .then((response) => {

            dispatch({
                type: GET_ALL_BOOTHS,
                payload: {
                    booths: response.data.data,
                    total: response.data.data.totalElements // Adjust based on API
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const getItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${BOOTHS}/${id}`, options)
        .then((response) => {
            dispatch({
                type: GET_BOOTH,
                payload: {
                    booth: response.data.data,
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const addItem = (payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        }
    }
    return axios.post(BASE_URL + BOOTHS, payload, apiHeader)
        .then(response => {
            console.log(response.data)
            // dispatch({ type: ADD_BOOTH, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const deleteItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.delete(BASE_URL + BOOTHS + '/' + id, apiHeader)
        .then(response => {
            // dispatch({ type: DELETE_BOOTH, payload: id });
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const editItem = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.patch(BASE_URL + BOOTHS + '/' + id, payload, apiHeader)
        .then(response => {
            // dispatch({ type: EDIT_BOOTH, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const clearItem = () => (dispatch) => {
    dispatch({ type: CLEAR_BOOTH });
}

